(function() {
  'use strict';

  angular.module('component.eventTypes', []);
})();
